
import WDButton from '../button/wd-button';
import WDModelItems from '../wd-model-items';

export default class WDDropdown extends WDModelItems
{
	constructor(cfg)
	{
		super(cfg);
		
		this.tabIndex = -1;
		this.classList.add('dropdown-menu');
		this.setAttribute('role', 'menu');
		this.on('item:selected',() => this.hide() );
		
		return this;
	};

	/**
	 * not sure if we want to use an override function, or a configurable string template
	 * will start with override for now
	 * @param {} data 
	 * @returns 
	 */
	createOptionHeader(data)
	{
		let label = data.label;
		if (data?.icon) label = `${data.icon} ${label}`;

		return wdc(`<div class="dropdown-header">${label}</div>`);
	}

	/**
	 * adds an entry outside of the model
	 * @param {*} data 
	 * @returns 
	 */
	add(data)
	{
		const params = typeof(data) == 'string' ? {label:data} : data;

		const item = new WDButton(params);
		item.classList.add('dropdown-item');
		item.classList.remove('btn');
		item.tabIndex = '-1';
		item.model = data;

		this.addModelItemEvents(item);
		this.append(item);

		return item;
	};

	createModelItem(data)
	{
		let item;

		if (data?.header === true)
		{
			item = this.createOptionHeader(data);
		}
		else if (data?.divider === true)
		{
			item = wdc('<div class="dropdown-divider"/>')
		}
		else
		{
			const labelStr = this.config.templates.label.interpolate(data);

			item = new WDButton({label:labelStr});
			item.classList.add('dropdown-item');
			item.classList.remove('btn');
			item.tabIndex = '-1';
			item.model = data;			

			if (this.config.templates?.icon)
			{
				const iconTmpl = this.config.templates.icon;

				//if given a template, interpolate it otherwise just use as an icon
				item.icon = iconTmpl.includes('${') ? iconTmpl.interpolate(item.model) : iconTmpl;
			}

			this.addModelItemEvents(item);
		}

		return item;
	};


	addModelItemEvents(item)
	{
		//watch for changes
		item.on('click', (evt) =>
		{
			this.trigger('item:selected', item);
		});

		// Keyboard navigation
		item.on('keydown', (e) =>
		{
			if (e.key === 'Enter') 
			{
				e.preventDefault();	//stops the keyboard from beeping on enter
				this.trigger('item:selected', item);
			}
			/* don't need anymore?
			else if (e.key == 'ArrowDown' || e.key == 'ArrowUp')
			{
				e.preventDefault();
			}
			*/
		});
	};

	addDivider()
	{
		const d = wdc('<div class="dropdown-divider"/>');
		this.append(d);
		return d;
	};

	addPrefix(obj)
	{
		const prefix = wdc('<div class="dropdown-item"/>');
		prefix.on('click', (evt) => evt.preventDefault());

		this.prepend(prefix);

		if (obj) prefix.append(obj);

		return prefix;
	};

	set dropup(val)
	{
		if (val == true) this.parentElement.classList.add('dropup');
		else this.parentElement.classList.remove('dropup');
	};

	set alignment(val)
	{
		if (val == 'end') this.classList.add('dropdown-menu-lg-end');
	}

	getInstance()
	{
		return bootstrap.Dropdown.getOrCreateInstance(this.previousElementSibling);
	}

	toggle()
	{
		const instance = this.getInstance();
		if (instance) instance.toggle();
	};

	show()
	{
		const instance = this.getInstance();
		if (instance) instance.show();
	};

	hide()
	{
		const instance = this.getInstance();
		if (instance) instance.hide();
	};

};

customElements.define('wd-dropdown', WDDropdown);

